import { createAsyncThunk } from '@reduxjs/toolkit';
import { callCreateTicket } from '../../services/TicketService';
import { callBFF } from '../../services/DebitPaymentService';
import { callUploadFiles } from '../../services/UploadFilesService';
import { contactBackBff, apiCucaIncidentBff } from '../../../src/config/paths';
import { TICKETS_CREATE, DEBIT_PAYMENT } from '../../constants/routes';
const PENDING_TICKET_STATUS = 409;

const errorMessageCreationFail = () =>
  'Hubo un problema al crear tu reclamo  intenta nuevamente';

const errorMessageUploadFail = (ticketId) =>
  `Hubo un problema al agregar tus imagenes a tu solicitud ${ticketId}, intenta nuevamente.`;

const pendingTicketPayload = (data) => ({
  hasPendingTicket: true,
  data: {
    rut: data?.form?.client?.documentId || '',
    correo: data?.form?.client?.email || '',
  },
});

export const createTicket = createAsyncThunk(TICKETS_CREATE, async (data) => {
  let isGuest = false;

  if (data.path === '') {
    data.path = '/' + TICKETS_CREATE;
    isGuest = true;
  }
  if (data.path === '/debitPayment') {
    data.path = '/' + DEBIT_PAYMENT;
  }

  let response;

  try {
    response = await (data.path === '/' + TICKETS_CREATE ||
    data.path === '/' + DEBIT_PAYMENT
      ? callBFF(data, apiCucaIncidentBff, isGuest)
      : callCreateTicket(data, contactBackBff));
  } catch (error) {
    if (error?.response?.status === PENDING_TICKET_STATUS) {
      return pendingTicketPayload(data);
    }
    throw Error(errorMessageCreationFail());
  }

  if (response?.status !== 200) {
    throw Error(errorMessageCreationFail());
  }

  const ticketId = response?.data?.data?.NumContacto;

  if (data?.images?.length) {
    const uploadFilesResponse = await callUploadFiles({
      files: data.images,
      ticketId,
      functionName: 'createTicket',
    });

    if (uploadFilesResponse.status !== 200) {
      throw Error(errorMessageUploadFail(ticketId));
    }
  }

  return response.data;
});
